import React, { Component } from 'react';
import decodeJwt from 'jwt-decode';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import MultipleBarChart from '../stats/chartMultipleBar';
const config = require('./../../config.json');

var monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dic'];

export default class GeneralStats extends Component {
    constructor(props) {
        super(props);
        let a;
        if (localStorage.getItem('token')) {
            a = decodeJwt(localStorage.getItem("token")).access_token
        }
        this.state = {
            token: a,
            series: [],
            categories: []
        }
        this.call_for_data = this.call_for_data.bind(this);
        this.diff = this.diff.bind(this);
        this.diffNumbers = this.diffNumbers.bind(this);
    }

    diff(from, to) {
        var result = [];
        var result2 = [];
        var datFrom = from; // new Date('1 ' + from);
        var datTo = to; // new Date('1 ' + to);
        if(datFrom < datTo) {
          var month = datFrom.getMonth();
          var toMonth = datTo.getMonth() + 1 + ((datTo.getYear() - datFrom.getYear())*12); //toMonth adjusted for year
          let i = 0;
          let year = datFrom.getFullYear();
          for(; month < toMonth; month++) { //Slice around the corner...
            result.push(monthNames[month % 12]);
            if (month % 12 === 0 && i === 0) {
                i = 1
                year = datTo.getFullYear();
            }
            result2.push([month % 12, year]);
          }
        }
    
        return [result, result2];
    }

    diffNumbers(from, to) {
        var result = [];
        var datFrom = from; // new Date('1 ' + from);
        var datTo = to; // new Date('1 ' + to);
        if(datFrom < datTo) {
          var month = datFrom.getMonth();
          var toMonth = datTo.getMonth() + 1 + ((datTo.getYear() - datFrom.getYear())*12); //toMonth adjusted for year
          for(; month < toMonth; month++) { //Slice around the corner...
            result.push(month % 12);
          }
        }
    
        return result;
    }

    componentDidMount() {
        this.call_for_data();
        let d = new Date();
        let nd = new Date();
        nd.setMonth(d.getMonth() - 12);
        this.setState({
            categories: this.diff(nd, d)[0]
        })
    }

    async call_for_data() {
        try {
            let a = this.state.token;
            fetch(config.API_URL + "/stats/general-earn", {
                method: 'GET',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': a
                }
            })
            .then(res => {
                return res.json();
            })
            .then(_data => {
                let carga = {};
                let uso = {};
                let dev = {};
                let d = new Date();
                let nd = new Date();
                nd.setMonth(d.getMonth() - 12);
                let monthNumbers = this.diff(nd, d)[1];
                monthNumbers.forEach(dat => {
                    carga[`${dat[0] + 1}-${dat[1]}`] = 0
                    uso[`${dat[0]+1}-${dat[1]}`] = 0
                    dev[`${dat[0]+1}-${dat[1]}`] = 0
                })
                // let newData = [];
                let dh, a, b, c, op;
                _data.forEach((row) => {
                    dh = moment(row["created_at"], 'DD/MM/YYYY').format("MM/DD/YYYY");
                    a = new Date(dh);
                    b = a.getMonth();
                    c = a.getFullYear();
                    op = `${b + 1}-${c}`;
                    if (row["info_type"].includes('carga_amount')) {
                        carga[op] = row["value"];
                    } else if (row["info_type"].includes('pago_amount')) {
                        uso[op] = row["value"];
                    } else if (row["info_type"].includes('devolucion_amount')) {
                        dev[op] = row["value"];
                    }
                })
                this.setState({
                    series: [{
                        name: 'Carga de saldo',
                        data: Object.values(carga)
                    }, {
                        name: 'Uso de saldo',
                        data: Object.values(uso)
                    }, {
                        name: 'Devoluciones',
                        data: Object.values(dev)
                    }]
                })
            })
            .catch(err => {
                console.log(err);
            })
        } catch (e) {
            console.log(e);
        }
    }
    
    render() {
        if (this.state.series.length === 0) {
            return (
                <div style={{position: "relative"}}>
                    <CircularProgress style={{marginLeft: '50%'}}/>
                </div>
            )
        }
        return (
            <MultipleBarChart series={this.state.series} chartId={this.props.chartId} groupId={this.props.groupId} categories={this.state.categories} />
        );
    }
}